// 根据该模块下的个文件名，来做归类区分：
const ja = {
	header: {
		homepage: 'トップページ',
		websiteManage: 'Webサイト管理',
		omniWebsiteManage: '店舗・Webサイト運営',
		storeManage: '店舗管理',
		websiteManageReview: 'ウェブサイトを審査の​​ために送信する',
		omniWebsiteManageReview: 'Webサイト管理',
		storeOnboarding: 'ストアステータスのクエリ',
		chargebackManage: '注文拒否の管理',
		withdrawalRecord: '出金記録',
		autoWithdrawalRecord: '自動出金記録',
		logisticsManage: '注文管理',
		transactionAnalysis: '取引分析',
		settlementStatement: '決算報告書',
		accountCenter: 'アカウントセンター',
		withdrawCenter: '出金口座',
		identityVerification: '実名認証',
		logOut: 'ログアウト',
		logoutFailed: 'ログアウトに失敗しました。後でもう一度お試しください',
		groupManagement: 'Webサイトグループ管理',
		omniGroupManagement: 'グループ管理',
		fundManagement: '資金管理',
		accountBalance: '口座残高',
		withdrawalDetail: '出金明細',
		riskManagement: 'リスク管理',
		chargebackManagement: '注文拒否の管理',
		riskTransactionManagement: 'リスク注文管理',
		statement: 'レポート管理',
		pingpongCollection: 'ピンポンレシート',
		currentsCollection: '送金口座',
		system: 'システム管理',
		permission: '権限管理',
		keySetting: 'キー管理',
		transactionDetail: '取引詳細',
		emailMsg: '通知受信設定',
		paymentLink: '決済リンク',
		brandList: 'ブランド情報のメンテナンス',
		templateManage: 'テンプレート管理',
		themeManage: 'テーマ管理',
		modeManage: 'スキーマ管理',
		invoice: '請求書',
		statementDownload: '明細書のダウンロード',
		transaction: '取引管理',
		refundLog: '返金照会',
		transitionLog: '取引照会',
		unsettledBalance: '未決済取引統計',
		blacklist: 'ブラックリスト管理',
		whitelist: 'ホワイトリスト管理',
		disputeManage: '紛争命令の管理'
	},
	webList: {
		accountChecking: 'あなたの支払いアカウントは審査中です。レビューが承認されると、資金の自動送金が開始されます。',
		accountNotAllow: '支払いアカウントが承認されていません。資金の流れに影響を与えないように、できるだけ早く処理してください。',
		accountNoAdd: 'まだ支払いアカウントを追加していません。お支払いの受領に影響を与えないように、できるだけ早く追加してください。',
		addNow: '今すぐ追加',
		addAgain: '再提出',
		websiteTotal: '合計を追加しました',
		website: 'ホームウェブサイト',
		websites: '合計',
		approve: '正常稼働',
		unbound: '承認待ち',
		pending: '審査中',
		abnormal: 'エラー',
		addWebsite: 'Webサイト追加',
		group: 'グループ',
		settleCurrency: '決済通貨',
		seeDetail: 'ウェブサイトの詳細',
		websiteHold: '申し訳ありませんが、あなたのウェブサイトは凍結されました。カスタマーサービスまでご連絡ください。現在の金額は引き続き通常どおり処理できますが、新規注文は受け付けられなくなります。',
		websiteClose: '申し訳ございませんが、ウェブサイトは閉鎖されました。カスタマーサービスまでご連絡ください。現在の金額は引き続き通常どおり処理できますが、新規注文は受け付けられなくなります。',
		websiteAbnormal: 'API ステータスが異常です。通常の料金徴収に影響を与えないように、時間内に再認証してください。',
		contact: 'カスタマーサービスにお問い合わせください',
		reSubmit: '再提出',
		modify: '改訂',
		contactToAdd: 'Web サイトを追加するにはカスタマー サービスにお問い合わせください',
		noSuportAddBySelf: '現時点では、Web サイトを個別に追加することはサポートされていません。カスタマー サービスにお問い合わせください。レビュー資料の提出についてご案内いたします。ご迷惑をおかけして誠に申し訳ございません。',
		pendingState: 'システム審査中',
		successState: '審査通過',
		failState: 'レビューに失敗しました',
		refuseState: 'この店舗は閉店しました',
		daysNeed: 'しばらくお待ちください',
		toBound: '承認されました。API が承認されるまでしばらくお待ちください',
		notFit: 'この店舗はコンプライアンス上の問題により一時的に閉店する必要があります',
		declineText: 'ご不明な点がございましたら、アカウント マネージャーにお問い合わせください',
		declineState: 'レビューに失敗しました',
		reject: 'ウェブサイトの審査に失敗しました',
		reSubmitPlease: '再送信してください',
		copySuccess: 'クリップボードにコピーされました',
		copyFail: 'コピーに失敗しました。後でもう一度お試しください',
		websiteTooMuch: 'Web サイトの数が制限に達しました',
		websiteMoreThanfifty: '最大 50 個の Web サイトを追加できます',
		riskTips1st: 'あなたが持っている',
		riskTips2nt: 'この取引にはリスクが伴います。取引開始後 7 日以内にカード所有者に確認のためご連絡ください。有効期限が切れた場合、取引は自動的にキャンセルされます。',
		riskTipsNoPermission: 'リスクの高い注文の場合、PingPong はリスクを検討して決定を下します。ご不明な点がございましたら、お問い合わせください。ご理解いただきありがとうございます。',
		riskTips3rd: 'この取引は危険なので、pingpong があなたのためにレビューしています。',
		dealImmediate: '対応する',
		view: '確認'
	},
	loginFooter: {
		copyright: '2015-%{year} © PingPong 無断複写・転載を禁じます。'
	},
	upload: {
		uploadField: 'ファイルアップロード',
		uploadFail: 'ファイルのアップロードに失敗しました。もう一度アップロードしてください',
		fileTooLarge:
			'ファイル %{name} のサイズが %{size}MB を超えています。圧縮してから再度アップロードしてください',
		addPicture: '画像を追加',
		reUpload: '再アップロード',
		imgNotFit: '画像フォーマットエラー',
		imgToBe: '画像は JPG、JPEG、PNG、BMP 形式である必要があります',
		tip: '確認',
		imgMax: 'アップロードする画像のサイズは 1MB を超えることはできません。',
		download: 'ダウンロード：'
	},
	global: {
		netError: 'ネットワークリクエストがタイムアウトしました。後でもう一度お試しください。',
		netBusy: 'ネットワークが混雑しています。後でもう一度お試しください (エラー',
		flowDetail: '走行詳細',
		flowId: 'シリアルナンバー',
		businessType: '取引種別',
		inComingTime: '返金クレジット時間',
		recordedTime: '入場時間',
		refundOriginTime: '返金額',
		orderOriginAmount: '元の注文金額',
		exchangeRate: '為替レート',
		refundAmount: '返金額',
		recordedAmount: '入力金額',
		confirm: '確認する',
		all: '全て',
		startDate: '開始時間',
		endDate: '終了時間',
		selectDate: '日付を選択してください'
	},
	wthdraw: {
		warning: ['規制要件に従って、注文情報は人民元為替決済の基礎として使用されます。情報が本物であることを確認してください。そうでない場合、支払いに影響が生じます。', 'CNYで外国為替を決済する必要がある場合は、最初に来てください。', '注文管理', '追加情報。']
	},
	wthdrawManual: {
		title: 'PingPong Checkout 出金操作ガイド',
		tips1: '1. PingPong Checkout Merchant Backstage - [アカウントセンター] - [出金口座] 右上隅で、銀行口座またはバーチャル口座の追加を申請できます',
		tips2: '2.「銀行口座追加」を申請する',
		tips3: '1) 同名の法人銀行口座の追加をサポートし、米ドル、ユーロ、ポンド、香港ドルなどの複数の通貨をサポートします。',
		tips4: '2) 追加後、レビューのために BD にタイムリーなフィードバックを提供する必要があります。審査後、この口座にお金を引き出すことができます。',
		tips5: '注: 人民元の直接現金引き出しはサポートされていません。人民元為替決済が必要な場合は、以下の手順3「バーチャル口座の申請」に従って、バーチャル口座（VA口座）に現金を引き出すことができます。',
		tips6: '3. バーチャル アカウント (「VA」アカウントとも呼ばれます) を申請します。',
		tips7: '3.1 初回申請の流れ',
		tips8: '実名認証と店舗情報審査を通過後、追加申請が可能となります。ストアはバーチャル アカウントを 1 つだけ申請でき、複数の決済通貨を選択できます。',
		tips9: '注: アカウント名はカスタマイズされています。仮想アカウント名を自分で入力し、アカウントでサポートされている通貨を選択して、「確認」をクリックします。後で仮想アカウントの通貨を追加したい場合は、仮想アカウントの詳細で「通貨を追加」をクリックして通貨を追加できます。初めてバーチャル アカウントを申請する場合は、情報を入力するために PingPong 支払いページにリダイレクトされます。入力する必要があるのは 1 回だけです。以降、バーチャルアカウントを申請する際に再度入力する必要はありません。入力が完了すると、出金口座ページにリダイレクトされます。',
		tips10: '1) PingPong 支払いアカウントをお持ちでない場合は、「今すぐ登録してバインドする」を選択して登録ページにジャンプします。',
		tips11: '2) すでに PingPong アカウントをお持ちの場合は、[PingPong を登録しました。今すぐログインしてバインドします] ページをクリックし、ログインしてバインドするためのユーザー名とパスワードを入力します。',
		tips12: '3) 実名検証を行っていない場合は、FI プラットフォーム上で実名情報を使用する (つまり、PingPong Checkout で実名情報を同期する) ボックスにチェックを入れることができ、再度入力する必要はありません。',
		tips13: '追加とバインドが完了すると、出金口座ページに戻り、仮想口座の申請が成功します。',
		tips14: '4) バーチャルアカウントを生成すると、「アカウントセンター」に「PingPong Collection」ボタンが表示されます。クリックすると、人民元の現金引き出し、サプライヤーへの支払い、その他の操作を行うための PingPong Collection Web サイトに直接ジャンプします。',
		tips15: '3.2 初回以外の申請',
		tips16: '1) 「アカウントセンター」の「アカウントの出金」をクリックして、出金アカウントページに入ります。このページでは、「バーチャル アカウントの申請」をクリックできます。仮想アカウント名を入力し、アカウントでサポートされている通貨を選択する必要があります。 「確認」をクリックして仮想アカウントを生成します。バーチャル アカウントの通貨を追加する必要がある場合は、バーチャル アカウントの詳細で [通貨を追加] をクリックして通貨を追加できます。',
		tips17: '2) バーチャルアカウントを生成すると、「アカウントセンター」に「PingPong Collection」ボタンが表示されます。クリックすると、交換操作のための PingPong Collection Web サイトに直接ジャンプします。',
		tips18: '注: バーチャル アカウントの通貨を追加する必要がある場合は、バーチャル アカウントの詳細で [通貨を追加] をクリックして通貨を追加できます。',
		tips19: '4. PingPong Checkoutの取得と引き出しのプロセス',
		tips20: '現在の出金可能額は、Webサイトの[ホームページ]または[資金管理]-[口座残高]に表示されます。 [出金]ボタンをクリックして、出金する銀行カードまたはバーチャルアカウントを選択します。',
		tips21: '知らせ：',
		tips22: '1) 初めて出金を開始するときは、デフォルトの出金口座に注意する必要があります。右側の「変更」をクリックして出金口座を切り替えることができます。出金口座を切り替える場合、操作切り替えを完了するには、事前に対応する出金口座を作成する必要があります。',
		tips23: '2) バーチャルアカウントにお金を引き出した後、[アカウントセンター]-[PingPong コレクション] をクリックして、PingPong コレクション操作にジャンプできます。',
		tips24: '5.物流情報のアップロード',
		tips25: '現金引き出し審査要件と人民元為替決済要件については、製品物流情報を完了する必要があります。部分建站ツールは自動上流物流をサポートします【shopify、店匠など】、その他は自動上流物流の必要性をサポートしません。',
		tips26: '手動アップロードの手順は次のとおりです。\u2003',
		tips27: '[注文管理]-[アップロード状況]をクリックし、「未アップロード」を選択し、「現在の結果をエクスポート」をクリックし、フォームに[商品名、物流注文番号、物流会社、物流クエリURL]を入力し、「情報一括アップロード」をクリックしてファイルをアップロードします。 (為替決済金額は物流アップロード後30分から1時間程度で同期されます)',
		tips28: '6. PingPong決済プラットフォーム運営プロセス',
		tips29: '6.1 出金口座の追加',
		tips30: '[アカウント センター] - [PingPong 領収書] をクリックして PingPong 回収プラットフォームに移動し、[アカウント センター] - [口座の出金] をクリックして、このページの「新しい口座を追加」をクリックして出金したい銀行カードを追加できます。銀行カードを追加した後、口座内の金額を引き出すことができます。',
		tips31: '6.2 支払いの回収と引き出しのプロセス',
		tips32: '[アカウント センター]-[PingPong 支払い] をクリックして、PingPong 支払いプラットフォームに移動します。',
		tips33: '「退会」をクリックすると退会ページにジャンプします。引き出す銀行カードを選択し、選択した銀行カードが対応している通貨に応じて両替を行うことができます。為替レートはページ上に表示されます。予定金額は為替レートに基づいて計算されます。 「確認」をクリックすると交換と出金が完了します。',
		tips34: '出金詳細で出金の詳細とステータスを確認できます。',
		tips35: '7. 出金に関するよくある質問',
		tips36: '(1) 出金時間',
		tips37: '通常、到着までに1〜3営業日かかります。祝日の場合は延期となります。',
		tips38: '(2) 法人引落銀行口座を追加すると審査中と表示されます。',
		tips39: 'フォローアップレビューのために、接続された BD にフィードバックを送信する必要があります。フィードバックがない場合は、常にレビュー中であることが表示され、次のステップに進むことができません。',
		tips40: '(3) 出金手数料',
		tips41: '出金は時間ごとに課金されます。具体的な料金については、署名された契約書を参照するか、BD にお問い合わせください。',
		tips42: '(4) 出金通貨',
		tips43: '出金がサポートされる通貨は、販売者のバックエンドで実際に表示される通貨に依存します。特別なニーズがある場合は、事前にドッキング BD と通信できます。'
	},
	common: {
		cancel: 'キャンセル',
		confirm: '確認する'
	},
	filter: {
		tradeType: {
			DEBIT: '決済',
			REFUND: '返金',
			AUTH: '事前認証',
			CAPTURE: '事前認証完了',
			VOID: '事前認証の取り消し',
			APPROVE: '審査通過',
			REJECT: 'レビュー拒否',
			PREDISPUTE_REFUND: '返金（チャージバック警告）'
		},
		tradeStatus: {
			PROCESSING: '処理中',
			PENDING: '支払い中',
			SUCCESS: '成功',
			FAILED: '失敗',
			CANCELED: 'キャンセル',
			REVIEW: '審査待ち'
		},
		chargebackReason: {
			DUTY: '不正利用',
			NO_RECEIVED: '商品未着',
			WRONG_GOODS: '商品相違',
			OTHERS: 'その他'
		},
		chargebackType: {
			retrieval: '調整',
			'1st_chargeback': '初回チャージバック',
			chargeback_reversal: 'チャージバック取消',
			'2nd_chargeback': '2回目のチャージバック',
			pre_arbitration: '事前仲裁',
			arbitration: '仲裁'
		},
		newFondType: {
			PREAUTHORIZE_SUCCESSFUL: '事前認証成功',
			PREAUTHORIZE_FAILED: '事前認証失敗',
			REFUND_SUCCESSFUL: '返金成功',
			REFUND_FAILED: '返金失敗',
			CAPTURE_SUCCESSFUL: '事前認証確認成功',
			CAPTURE_FAILED: '事前認証確認失敗',
			PAID_SUCCESSFUL: '支払い成功',
			PAID_FAILED: '決済失敗',
			INBOUND_SUCCESSFUL: '入金成功',
			VOID_SUCCESSFUL: '事前認証取消成功',
			VOID_FAILED: '事前認証取消失敗',
			REVIEW: '審査待ち',
			CANCELED: '取引取消'
		},
		fondType: {
			DEBIT: '注文入金',
			DEPOSIT: '追加保証金',
			MERCHANT_FEE_SETTLE: '送金手数料',
			FEE: '費用控除',
			REFUND: '返金',
			DEPOSIT_RETURN: '保証金返金返還',
			DEPOSIT_RELEASE: '保証金期限到来返還',
			SETTLE: '送金',
			PURCHASE: '取引',
			PURCHASE_FEE: '取引手数料',
			REFUND_FEE: '返金手数料'
		},
		tradeTypeName: {
			CAPTURE_SUCCESSFUL: '事前認証確認成功',
			CAPTURE_PROCESSING: '事前認証確認中',
			CAPTURE_FAILED: '事前認証確認失敗',
			REFUND_PROCESSING: '返金中',
			REFUND_SUCCESSFUL: '返金成功',
			REFUND_FAILED: '返金失敗',
			PAID_SUCCESSFUL: '支払い成功',
			PAID_FAILED: '決済失敗',
			PAID_PENDING: '支払い中',
			PREAUTHORIZE_SUCCESSFUL: '事前認証成功',
			PREAUTHORIZE_FAILED: '事前認証失敗',
			CAPTURE_FULL_SUCCESSFUL: '全額事前認証確認成功',
			CAPTURE_FULL_FAILED: '全額事前認証確認失敗',
			CAPTURE_PARTIAL_SUCCESSFUL: '部分事前認証確認成功',
			CAPTURE_FULL_PROCESSING: '全額事前認証確認中',
			CAPTURE_PARTIAL_PROCESSING: '部分事前認証確認中',
			CAPTURE_PARTIAL_FAILED: '部分事前認証確認失敗',
			CAPTURE_EXPIRED: '事前認証期限切れ',
			INBOUND_SUCCESSFUL: '入金成功',
			INBOUND_FAILED: '入金失敗',
			REFUND_FULL_PROCESSING: '全額返金中',
			REFUND_FULL_SUCCESSFUL: '全額返金成功',
			REFUND_FULL_FAILED: '全額返金失敗',
			REFUND_PARTIAL_PROCESSING: '部分返金中',
			REFUND_PARTIAL_SUCCESSFUL: '部分返金成功',
			REFUND_PARTIAL_FAILED: '部分返金失敗',
			REVERSAL_SUCCESSFUL: '事前認証取消成功',
			REVERSAL_FAILED: '事前認証取消失敗',
			DEPOSIT_AUTO_RETURNED: '保証金満期返還',
			REFUND_RETURNED: '返金時保証金返還',
			CHARGE_BACK: 'チャージバック',
			CHARGE_BACK_RETURNED: 'チャージバック返還',
			EXPENDITURE_SUSSEESFUL: '支出成功',
			EXPENDITURE_FAILED: '支出失敗',
			RECEIPT: '入金'
		},
		recordState: {
			INPROCESS: '送金中',
			RECEIVED: '送金中',
			PENDING: '送金中',
			PART_SUCCESS: '一部送金成功',
			SUCCESS: '送金成功',
			FAILED: '送金失敗',
			RETURN: '組戻し'
		},
		merchantDealStatus: {
			expired: '期限切れ',
			failed: '異議申立失敗',
			pending: '対応待ち',
			processed: '処理済み',
			refunded: '返金済み',
			revoked: 'カード保有者取消',
			success: '異議申立成功',
			waiver_appeal: '異議申立放棄'
		}
	}
}
export default ja
